import { render, staticRenderFns } from "./ComponentsLayoutWithNavbar.vue?vue&type=template&id=2b7b0428&scoped=true"
import script from "./ComponentsLayoutWithNavbar.vue?vue&type=script&lang=js"
export * from "./ComponentsLayoutWithNavbar.vue?vue&type=script&lang=js"
import style0 from "./ComponentsLayoutWithNavbar.vue?vue&type=style&index=0&id=2b7b0428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b0428",
  null
  
)

export default component.exports